export default "__VITE_ASSET__83c936b1__"